































































































































































































































































































































































































































































































interface checkStatus {
    hasInitBalance: number;
    hasVoucher: number;
    hasTemplate: number;
    hasFixedAssets: number;
}
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ThDropdownVue from "../components/ThDropdown.vue";
import SubSideNavVue from "../components/Subject/SubSideNav.vue";
import EditSubVue from "../components/Subject/EditSub.vue";
import TrialBalanceVue from "../components/Subject/TrialBalance.vue";
import AssitInitDataVue from "../components/Subject/AssitInitData.vue";
import ForeignCurrencyVue from "../components/Subject/ForeignCurrency.vue";
import AmountCurrencyVue from "../components/Subject/AmountCurrency.vue";
import NumForeignVue from "../components/Subject/NumForeign.vue";
import OnekeyBlockVue from "../components/Subject/OnekeyBlock.vue";
import SubjectFailVue from "../components/Subject/SubjectFail.vue";
import version from "@/version";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "side-nav": SubSideNavVue,
        "editSub-dialog": EditSubVue,
        "trialBalance-dialog": TrialBalanceVue,
        "assitInit-dialog": AssitInitDataVue,
        "amount-currency": AmountCurrencyVue,
        "num-foreign": NumForeignVue,
        "foreign-currency": ForeignCurrencyVue,
        "onekey-block": OnekeyBlockVue,
        "subject-fail": SubjectFailVue,
    }
})
export default class Subject extends Vue {
    @Prop({ type: Boolean })
    isDialog!: boolean;

    activeId: number = 0
    subNavCode: string = "资产"
    startPeriod: string = ""
    subjectData: Subject.Subject[] = []
    selectedIndex: number = 0;//选中行
    showOneKey: boolean = false  //是否打开一键导入
    failSubject: Voucher.VoucherImport[] = []
    message: string = ""
    showFail: boolean = false
    isClear: boolean = false

        // 下载
    mainDownload() {
            let url = `${Vue.axios.defaults.baseURL}export/subjects/balance?accountBookId=${this.$store.state.accountBook.id}&version=${version}&token=${this.$store.state.account.token}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
    }
    mounted() {
        this.fetchData()
    }
    closeFail() {
        this.showFail = false
    }
    // 一键导入
    onekeyClose(val?: boolean, res?: any) {
        if (val) {
            if (res.data.code === 1) {
                this.failSubject = res.data.data.needToSetAssSubjects;
                this.message = res.data.message
                this.$nextTick(() => {
                    this.fetchData()
                })
                this.showFail = true
            }
            if (res.data.code === 200) {
                this.$message({
                    type: "success",
                    message: "导入成功"
                })
                this.$nextTick(() => {
                    this.fetchData()
                })
            } else {
                this.$message({
                    type: "warning",
                    message: "导入失败"
                })
            }
            this.showOneKey = false
        } else this.showOneKey = false
    }
    // 新增编辑科目
    showEditSub: boolean = false
    types: string[] = []
    //编辑科目，添加下级科目对象数据
    editSubjectForm: EditSubject = {
        type: "",
        id: null,
        parentSubjectCode: "",
        parentSubjectName: "",
        subjectCode: "",
        subjectName: "",
        measuringUnit: "",
        currSymbol: "",
        dimAccountType: false,
        showTip: false,
        canNotEdit: false,
        assistDisabled: false,
        toSelectAss: false
    };
    // 辅助科目期初
    rowSubject: Subject.Subject | null = null
    showAssit: boolean = false;
    assistInitTable(row: Subject.Subject) {
        this.rowSubject = null
        this.rowSubject = row
        this.showAssit = true
    }
    closeAssit() {
        this.showAssit = false
    }
    successAssit() {
        this.fetchData()
    }
    // 判断是否有 数量金额数量外币外币金额
    modalBtns: number = 0
    isDialogOn: boolean = false
    modalData: ModalData | null = null
    get canImport() {
        return (
            !this.isDialogOn &&
            +this.$store.state.accountBook.closePeriod === 0
        );
    }
    showAmountCurrency: boolean = false
    showAmountForeign: boolean = false
    showForeignCurrency: boolean = false
    // 数量金额
    showAmountCurrencyFn() {
        this.getModalData(1);
    }
    // 数量外币
    showAmountForeignFn() {
        this.getModalData(2);
    }
    // 外币金额
    showForeignCurrencyFn() {
        this.getModalData(3);
    }
    //获取模态框数据 数量金额数量外币外币金额
    getModalData(num: number) {
        Vue.axios
            .post(`subjects/findcurrency`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                this.modalData = res.data
                if (num == 1) {
                    this.showAmountCurrency = true;
                } else if (num == 2) {
                    this.showAmountForeign = true;
                } else {
                    this.showForeignCurrency = true;
                }
            });
    }

    // 添加/编辑科目的判断
    editSubFirst(row: Subject.Subject, subType: string, checkStatus: checkStatus) {
        return new Promise((resolve, reject) => {
            this.editSubjectForm.type = subType;
            this.types = row.dimAccountTypes;
            this.editSubjectForm.canNotEdit = false
            if (subType === "编辑") {
                if (row.isInit === 1) this.editSubjectForm.canNotEdit = true;
                if (row.pno) this.editSubjectForm.parentSubjectCode = row.pno;
                if (row.ptext) this.editSubjectForm.parentSubjectName = row.ptext;
                this.editSubjectForm.subjectCode = row.no;
            }
            else {
                if (row.isInit === 1) this.editSubjectForm.canNotEdit = false;
                if (row.dimAccountType != null) {
                    if (checkStatus.hasInitBalance == 1 || checkStatus.hasVoucher == 1 || checkStatus.hasTemplate == 1 || checkStatus.hasFixedAssets == 1)
                        this.editSubjectForm.assistDisabled = true;
                } else this.editSubjectForm.assistDisabled = false;
            }
            resolve();
        })
    }
    editSubSecond(row: Subject.Subject, subType: string, checkStatus: checkStatus) {
        return new Promise((resolve, reject) => {
            if (row.leaf === 1) {
                if (checkStatus.hasInitBalance == 1 ||
                    checkStatus.hasVoucher == 1) {
                    if (subType === "新增") {
                        this.$msgbox({
                            message:
                                "上级科目已使用，保存后新增科目将替代期初数据中的上级科目，您确定是否继续？",
                            title: "温馨提示",
                            confirmButtonText: "确定",
                            showCancelButton: true,
                            cancelButtonText: "取消"
                        })
                            .then((action: any) => {
                                if (action == "confirm") {
                                    this.editSubjectForm.canNotEdit = false;
                                    if (subType == "新增") {
                                        this.editSubjectForm.parentSubjectCode =
                                            row.no;
                                        if (row.text) this.editSubjectForm.parentSubjectName =
                                            row.text;
                                        this.editSubjectForm.subjectName =
                                            "";
                                        this.editSubjectForm.toSelectAss = true;
                                        this.isMaxCode(row)
                                        resolve()
                                    }
                                }
                            }).catch(() => {
                                reject()
                            });
                    } else if (subType === "编辑") {
                        if (row.dimAccountType != null) this.editSubjectForm.assistDisabled = true;
                        else this.editSubjectForm.toSelectAss = true;
                        resolve()
                    }
                }
                else {
                    if (subType === "新增") {
                        this.editSubjectForm.parentSubjectCode = row.no;
                        if (row.text) this.editSubjectForm.parentSubjectName = row.text;
                        this.editSubjectForm.subjectName = "";
                        this.isMaxCode(row);
                    } else {
                        this.editSubjectForm.parentSubjectCode = (<string>row.pno);
                        if (row.text) this.editSubjectForm.parentSubjectName = (<string>row.ptext);
                        this.editSubjectForm.subjectName = (<string>row.text);
                    }
                    resolve()
                }
            } else {
                if (subType === "新增") {
                    this.editSubjectForm.parentSubjectCode = row.no;
                    if (row.text) this.editSubjectForm.parentSubjectName = row.text;
                    this.editSubjectForm.subjectName = "";
                    this.isMaxCode(row)
                } else this.editSubjectForm.assistDisabled = true;
                resolve();
            }
        })
    }
    row: Subject.Subject | null = null
    async editSub(row: Subject.Subject, subType: string) {
        this.editSubjectForm = {
            type: "",
            id: null,
            parentSubjectCode: "",
            parentSubjectName: "",
            subjectCode: "",
            subjectName: "",
            measuringUnit: "",
            currSymbol: "",
            dimAccountType: false,
            showTip: false,
            canNotEdit: false,
            assistDisabled: false,
            toSelectAss: false
        };
        this.row = row;
        this.editSubjectForm.toSelectAss = false;
        this.editSubjectForm.assistDisabled = false;
        this.editSubjectForm.showTip = false;
        this.editSubjectForm.type = subType;
        if (row.id) this.editSubjectForm.id = row.id;
        if (row.text) this.editSubjectForm.subjectName = row.text;
        if (row.measuringUnit) this.editSubjectForm.measuringUnit = row.measuringUnit;
        if (row.currSymbol) this.editSubjectForm.currSymbol = row.currSymbol;
        let res = await Vue.axios.post("subjects/" + row.id + "/checksubject", { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
        let checkStatus = res.data;
        // try 分步骤判断弹窗打开的情况及页面数据
        await this.editSubFirst(row, subType, checkStatus);
        await this.editSubSecond(row, subType, checkStatus);
        this.showEditSub = true;
    }
    // 判断科目编码是否已达到最大上限
    isMaxCode(row: Subject.Subject) {
        Vue.axios
            .get(`subjects/` + row.id + `/createno`)
            .then(res => {
                this.editSubjectForm.subjectCode = res.data.no;
                if (row.no === res.data.no) {
                    this.$alert(
                        "亲，当前科目编码已达到最大值，请自定义编写编码",
                        "温馨提示"
                    )
                }
            });
    }
    editSubClose() {
        this.fetchData();
        this.showEditSub = false;
    }
    editSubSuccess(isClose?: boolean) {
        // 判断是否是 保存并退出
        if (!isClose) {
            this.fetchData();
        }
        else {
            this.fetchData();
            this.showEditSub = false
        }

    }

    // 切换侧边栏
    accItem(item: NavList) {
        this.subNavCode = item.name
        this.fetchData()
    }
    fetchData() {
        Vue.axios
            .post(`subjects/findall`, {
                accountBookId: this.$store.state.accountBook.id,
                subtypeCode: this.subNavCode
            })
            .then(res => {
                this.isClear = res.data.isClear
                this.startPeriod = res.data.startPeriod
                this.subjectData = res.data.subjects
                this.modalBtns = res.data.buttonStatus
            });
    }
    // 删除行
    deleteSubject(row: Subject.Subject) {
        Vue.axios
            .post(`subjects/` + row.id + `/checksubject`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
            .then(res => {
                if (
                    res.data.hasInitBalance != 1 &&
                    res.data.hasVoucher != 1 &&
                    res.data.hasTemplate != 1 &&
                    res.data.hasFixedAssets != 1
                ) {
                    this.$msgbox({
                        message: "确定要删除这个科目吗？",
                        title: "温馨提示",
                        confirmButtonText: "确定",
                        showCancelButton: true,
                    }).then((action: any) => {
                        if (row.id) this.delRow(action, row.id)
                    });
                }
                else {
                    Vue.axios
                        .get(`subjects/deltip?id=` + row.id)
                        .then(res => {
                            this.$msgbox({
                                message:
                                    res.data.PromptMessage ||
                                    "确定要删除这个科目吗？",
                                title: "温馨提示",
                                confirmButtonText: "确定",
                                showCancelButton: true
                            })
                                .then((action: any) => {
                                    if (row.id) this.delRow(action, row.id)
                                });
                        });
                }
            });

    }
    // 删除数据
    delRow(action: any, id: number) {
        if (action == "confirm") {
            Vue.axios
                .post(`subjects/` + id + `/delete`, {
                    accountBookId: this.$store.state.accountBook.id,
                    subtypeCode: this.subNavCode
                })
                .then(res => {
                    this.fetchData()
                    this.$message.success("删除成功！");
                });
        }
    }
    //展示隐藏图标
    showIcos(event: any) {
        let icons: any = event.currentTarget.querySelectorAll(".icons");
        for (let i = 0; i < icons.length; i++) {
            icons[i].style.display = "inline-block";
        }
    }
    hideIcos(event: any) {
        let icons: any = event.currentTarget.querySelectorAll(".icons");
        for (let i = 0; i < icons.length; i++) {
            icons[i].style.display = "none";
        }
    }
    // 启用禁用科目
    disableSubject(row: Subject.Subject) {
        Vue.axios
            .post(`subjects/` + row.id + `/isdisable`)
            .then(res => {
                this.fetchData()
            });
    }
    // 试算平衡弹窗
    showTrialBalance: boolean = false
    isTrialBalance() {
        this.showTrialBalance = true;
    }
    closeTrialBalance() {

    }
    successTrialBalance() { }
    //进入焦点，保存缓存数据
    tmpData: string = ""
    saveTmp(e: any) {
        this.tmpData = e.target.value;
        e.target.select();
    }
    //编辑金额
    editBalance(row: Subject.Subject, e: any, attr: any) {
        if (e.target.value != this.tmpData) {
            let reg = /^(\-|\+)?\d+(\.\d+)?$/,
                val = e.target.value.replace(/,/g, "");
            if (reg.test(val)) val = val;
            else val = 0;
            if (row.balance) row.balance[attr] = val;
            Vue.axios
                .post(`subjects/modifybalance`, row)
                .then(res => {
                    this.fetchData()
                });
        }
    }
    addCurrentRow(index: number) {
        this.activeId = index
    }

    // 清理下级科目
    clearSubject(id: number) {
        this.$msgbox({
            message: "是否确认清理未使用的下级科目？",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true
        }).then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .post(`subjects/` + id + `/clear`, {
                        accountBookId: this.$store.state.accountBook.id,
                        subtypeCode: this.subNavCode
                    })
                    .then(res => {
                        this.fetchData()
                        this.$message.success("成功清理" + res.data + "条下级科目！");
                    });
            }
        });
    }
    clearSub(){
        this.$msgbox({
            message: "该操作会删除所有余额数据，是否确定初始化余额",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                .post(`subjects/clearbalance`, {
                    accountBookId: this.$store.state.accountBook.id,
                })
                .then(res => {
                    this.fetchData()
                });
            }
        });

    }
}
